<template>
  <div>
    <label for="select-empresa" class="font_size_label label">{{label}}</label>
    <v-select
      id="select-empresa"
      :options="options"
      v-model="selectedItem"
      :clearable="true"
      label="descricao"
      :disabled="disabled"
      :loading="loading"
      :placeholder="placeholder"
    >
      <span slot="no-options">Nenhuma opção selecionável.</span>
    </v-select>
  </div>
</template>

<script>
import { BFormGroup, BFormRadio, BFormRadioGroup } from "bootstrap-vue";
import vSelect from "vue-select";

export default {
  components: {
    BFormGroup,
    BFormRadio,
    BFormRadioGroup,
    vSelect,
  },

  props: {
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    value: {
        type: Object | null,
        required: true
    },
    label: {
      type: String,
      required: false,
      default: "Selecionar",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "Todos",
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    selectedItem: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  }
};
</script>

<style>
  .radio-empresa .custom-radio.b-custom-control-sm .custom-control-label::before, [dir=ltr] .input-group-sm .custom-radio .custom-control-label::before {
      left: 0;
  }

  .company-filter .vs__dropdown-toggle{
    font-size: 15px;
    border-radius: 8px;
    margin: 0px;
  }

  .company-filter-disabled {
    .vs__selected {
      color: #5E5873 !important;
      font-size: 14px !important;
    }
    .vs__deselect {
      display: none !important;
    }
  }
</style>
